// this file is a workaround for ajv formats
import { fullFormats, } from 'ajv-formats/dist/formats.js';
// @ts-expect-error
import idn from 'ajv-formats-draft2019/idn.js';
import { formats, } from './ajv/customFormats.js';
// eslint-disable-next-line import/no-default-export
export default {
    ...fullFormats,
    ...idn,
    ...formats,
};
//# sourceMappingURL=formats.js.map